if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();

        // Read products_per_page from attribute
        const wrapper = this.querySelector('.swiper-wrapper');
        const productsPerPage = parseFloat(wrapper?.dataset.productsPerPage || 1);
        const productsPerPageMobile = parseFloat(wrapper?.dataset.productsPerPageMobile || 1);

        this.sliderOptions = {
          slidesPerView: productsPerPage + 0.8, // default desktop value
          spaceBetween: 4,
          loop: false,
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: false,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          breakpoints: {
            0: {
              slidesPerView: productsPerPageMobile + 0.3, // mobile
              spaceBetween: 4.8,
            },
            768: {
              slidesPerView: productsPerPage - 0.2, // tablet & up
              spaceBetween: 4,
            }
          }
        };
      }

      connectedCallback() {
        const slider = this.querySelector('.swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
